//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import shortId from "short-uuid";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import draggable from "vuedraggable";
import { $http } from "@/assets/js/appFunc";

function generateSanitizedCamelIshCase(str) {
    // sanitize: removes non alphanumeric chars except "_"
    // camel-ish case: unlike camel case this function preserves uppercase letters inside words
    str = str.replace(/[^a-zA-Z0-9 _]/g, "");
    return str.split(" ").reduce((acc, word, index) => {
        if (!index) return `${acc}${(word[0] && word[0].toLowerCase()) || ""}${word.slice(1)}`;
        return `${acc}${(word[0] && word[0].toUpperCase()) || ""}${word.slice(1)}`;
    }, "");
}

export default {
    name: "ImportEntityModal",
    components: {
        AQModal,
        AQInput,
        AQUploader,
        AQCard,
        AQDropdown,
        draggable,
        AQCheckbox,
        AQTooltip
    },
    data() {
        return {
            showModal: true,
            entity: {
                name: "",
                code: ""
            },
            entityData: {},
            fileUploaded: false,
            dataForm: null,
            errorMsgUploader: null,
            isSuccess: false,
            emptyName: false,
            emptyCode: false,
            wrongPatternErr: false,
            wrongPatternErrCode: false,
            duplicatedEntityName: false,
            duplicatedEntityCode: false,
            entityList: [],
            draggableColumns: [],
            inputNameKey: 0,
            inputCodeKey: 0,
            counter: 0,
            // eslint-disable-next-line no-useless-escape
            validatePatternName: new RegExp(/^[ a-zA-Z0-9_\/\n/-]{1,60}$/),
            validatePatternCode: new RegExp(/^[a-zA-Z0-9_]{1,60}$/),
            allColumns: true,
            allColumnIDs: [],
            name: "",
            code: "",
            type: "",
            selectedFields: [],
            fileName: "",
            typeOpts: [
                {
                    value: "string",
                    label: "String"
                },
                {
                    value: "integer",
                    label: "Integer"
                },
                {
                    value: "decimal",
                    label: "Decimal"
                },
                {
                    value: "datetime",
                    label: "Date-time"
                },
                {
                    value: "date",
                    label: "Date"
                },
                {
                    value: "time",
                    label: "Time"
                },
                {
                    value: "BOOLEAN",
                    label: "Boolean"
                }
            ],
            defaultSource: "string",
            initialVals: [],
            fileError: false,
            loadingState: false
        };
    },
    computed: {
        importLabel() {
            return {
                label: this.$t("globalDataModel.importEntity")
            };
        },
        isError() {
            return this.emptyName || this.wrongPatternErr || this.duplicatedEntityName;
        },
        isErrorCode() {
            return (this.emptyCode && !this.isError) || this.wrongPatternErrCode || this.duplicatedEntityCode;
        },
        errorLabel() {
            let errorMsg;
            if (this.emptyName) {
                errorMsg = this.$t("globalDataModel.emptyName");
            } else if (this.wrongPatternErr) {
                errorMsg = this.$t("globalDataModel.wrongPattern");
            } else if (this.duplicatedEntityName) {
                errorMsg = this.$t("globalDataModel.duplicateName");
            }
            return errorMsg;
        },
        errorLabelCode() {
            let errorMsgCode;
            if (this.emptyCode) {
                if (this.entity.name) {
                    errorMsgCode = this.$t("globalDataModel.emptyName");
                }
            } else if (this.wrongPatternErrCode) {
                errorMsgCode = this.$t("globalDataModel.wrongPatternCode");
            } else if (this.duplicatedEntityCode) {
                errorMsgCode = this.$t("globalDataModel.duplicateCode");
            }
            return errorMsgCode;
        }
    },
    watch: {
        "entity.code": {
            handler(newVal) {
                const validatePattern = new RegExp(/^[a-zA-Z0-9_]{1,60}$/);
                this.wrongPatternCode = newVal && !validatePattern.test(newVal);
                this.emptyCode = !newVal;
                this.wrongPatternErrCode = this.wrongPatternCode;
                this.duplicatedEntityCode = false;
                const foundEntityCode = this.entityList.find(element => element.code === newVal);
                if (foundEntityCode) {
                    this.duplicatedEntityCode = true;
                } else {
                    this.duplicatedEntityCode = false;
                }
            }
        }
    },
    mounted() {
        this.getEntities().then((entList) => {
            for (let i = 0; i < entList.data.length; i++) {
                this.entityList.push({
                    name: entList.data[i].name,
                    code: entList.data[i].code
                });
            }
        });
    },
    methods: {
        ...mapActions("dataStore", ["getEntities"]),
        actionsDlg($event) {
            if ($event === "save") {
                if (!this.fileUploaded) {
                    this.fileError = true;
                } else {
                    this.checkAlphaColValues();
                    this.emptyName = !this.entity.name;
                    this.emptyCode = !this.entity.code;
                    const itemError = this.draggableColumns.find(item => item.error && !!item.checked) || false;
                    const itemErrorCode = this.draggableColumns.find(item => item.errorCode && !!item.checked) || false;
                    if (!this.emptyName && !this.emptyCode && !this.wrongPatternErr && !this.wrongPatternErrCode && !itemError
                && !itemErrorCode && !this.duplicatedEntityName && !this.duplicatedEntityCode) {
                        const formattedArray = [];
                        for (let i = 0; i < this.draggableColumns.length; i++) {
                            for (let j = 0; j < this.selectedFields.length; j++) {
                                if (this.draggableColumns[i].uuid === this.selectedFields[j]) {
                                    formattedArray.push({
                                        code: this.draggableColumns[i].code,
                                        name: this.draggableColumns[i].name,
                                        csvName: this.draggableColumns[i].csvName,
                                        type: this.draggableColumns[i].type[0].value
                                    });
                                }
                            }
                        }
                        const payload = {
                            code: this.entity.code,
                            name: this.entity.name,
                            type: "PLATFORM",
                            columns: formattedArray || [],
                            filename: this.fileName,
                            importType: "CREATE_ENTITY",
                            csvHeaders: []
                        };
                        this.createFromFile(payload);
                    }
                }
            } else if ($event === "close") {
                this.$emit("input", false);
            }
        },
        uploadFile(file) {
            this.dataForm = new FormData();
            const fileBlob = new Blob([file[0]]);
            this.dataForm.append("file", fileBlob, file[0].name);
            this.loadingState = true;
            $http({
                type: "POST",
                url: "/datastore/csv/upload?importType=CREATE_ENTITY",
                noNotify: true,
                data: this.dataForm
            }, true).then(
                (data) => {
                    this.loadingState = false;
                    this.fileError = false;
                    this.fileName = data.data.filename;
                    this.draggableColumns = data.data.columns;
                    if (this.draggableColumns.length) {
                        for (let i = 0; i < this.draggableColumns.length; i++) {
                            this.draggableColumns[i].uuid = shortId.uuid();
                            this.draggableColumns[i].checked = true;
                            this.draggableColumns[i].name = this.draggableColumns[i].name.trim();
                            this.allColumnIDs.push(this.draggableColumns[i].uuid);
                            this.generateAttributeCode(this.draggableColumns[i]);
                        }
                        this.checkColValuesImport();
                    }
                    this.initialVals = JSON.parse(JSON.stringify(data.data.columns));
                    for (let i = 0; i < this.initialVals.length; i++) {
                        const valOfType = this.initialVals[i].type;
                        this.initialVals[i].type = [];
                        for (let j = 0; j < this.typeOpts.length; j++) {
                            if (this.typeOpts[j].value.toLowerCase() === valOfType.toLowerCase()) {
                                this.initialVals[i].type.push(this.typeOpts[j]);
                            }
                        }
                    }
                    this.selectedFields = [...this.allColumnIDs];
                    this.isSuccess = true;
                    this.fileUploaded = true;
                },
                err => {
                    this.loadingState = false;
                    this.fileError = false;
                    this.setErrors(err.response.data.error);
                }
            );
        },
        setErrors(err) {
            if (err.includes("is empty")) {
                this.errorMsgUploader = this.$t("globalDataModel.errorUploadEmptyFile");
            } else if (err.includes("has duplicated columns")) {
                this.errorMsgUploader = this.$t("globalDataModel.errorUploadDuplicatedColumns");
            } else if (err.includes("reading CSV header")) {
                this.errorMsgUploader = this.$t("globalDataModel.errorUploadCSVHeader");
            } else {
                this.errorMsgUploader = err;
            }
        },
        deleteFile() {
            this.fileUploaded = false;
            this.errorMsgUploader = null;
        },
        createFromFile(payload) {
            $http({
                type: "POST",
                url: "/datastore/csv/import",
                data: payload
            }, true).then(
                () => {
                    this.$emit("input", false);
                    this.$toast.showNotify({
                        type: "info",
                        message: this.$t("globalDataModel.createSuccessMsg")
                    });
                },
                err => {
                    if (err.response.status === 409) {
                        if (err.response.data.entityNameInvalid) {
                            this.showModal = true;
                            this.duplicatedEntityName = true;
                        }
                        if (err.response.data.entityCodeInvalid) {
                            this.showModal = true;
                            this.duplicatedEntityCode = true;
                        }
                    }
                }
            );
        },
        checkEntityName() {
            // eslint-disable-next-line
            const validatePattern = new RegExp(/^[ a-zA-Z0-9_\/\n/-]{1,60}$/);
            this.wrongPattern = !validatePattern.test(this.entity.name);
            this.emptyName = !this.entity.name.trim();
            this.entity.name = this.entity.name.trim();
            this.wrongPatternErr = this.wrongPattern;
            this.duplicatedEntityName = false;
            const foundEntityName = this.entityList.find(element => element.name === this.entity.name);
            if (foundEntityName) {
                this.duplicatedEntityName = true;
            } else {
                this.duplicatedEntityName = false;
            }
        },
        checkEntityNameGenerateCode() {
            this.checkEntityName();
            this.generateEntityCode();
        },
        generateEntityCode() {
            const camelCode = generateSanitizedCamelIshCase(this.entity.name);
            const allCodesSet = this.entityList.reduce(
                (acc, entity) => acc.add(entity.code), new Set()
            );
            let newCode = camelCode;
            let iterator = 0;
            while (allCodesSet.has(newCode)) {
                iterator++;
                newCode = `${camelCode}${iterator}`;
            }
            this.entity.code = newCode;
        },
        errorLabelAttribute(item) {
            let errorMsg;
            if (!item.name) {
                errorMsg = this.$t("globalDataModel.emptyName");
            } else if (!this.validatePatternName.test(item.name)) {
                errorMsg = this.$t("globalDataModel.wrongPattern");
            } else if (this.checkDuplicatedColName(item)) {
                errorMsg = this.$t("globalDataModel.duplicateName");
            }
            return errorMsg;
        },
        errorLabelAttributeCode(item) {
            let errorMsg;
            if (!item.code) {
                if (item.name) {
                    errorMsg = this.$t("globalDataModel.emptyName");
                }
            } else if (!this.validatePatternCode.test(item.code)) {
                errorMsg = this.$t("globalDataModel.wrongPatternCode");
            } else if (this.checkDuplicatedColCode(item)) {
                errorMsg = this.$t("globalDataModel.duplicateCode");
            }
            return errorMsg;
        },
        checkAttributeName(item, blur) {
            item.error = false;
            item.error = !this.validatePatternName.test(item.name) || !item.name;
            this.checkColValuesImport();
            if (blur && !item.name) {
                this.inputNameKey++;
            }
        },
        checkAttributeNameGenerateCode(item) {
            this.checkAttributeName(item);
            this.generateAttributeCode(item);
        },
        generateAttributeCode(item) {
            const camelCode = generateSanitizedCamelIshCase(item.name);
            const allCodesSet = this.draggableColumns.reduce(
                (acc, attribute) => {
                    if (attribute !== item) {
                        acc.add(attribute.code);
                    }
                    return acc;
                },
                new Set().add("id")
            );
            let newCode = camelCode;
            let iterator = 0;
            while (newCode && allCodesSet.has(newCode)) {
                iterator++;
                newCode = `${camelCode}${iterator}`;
            }
            item.code = newCode;
            this.checkColValuesImportCode();
        },
        checkDuplicatedColCode(item) {
            const codeToReturn = typeof item === "string" ? item : item.code;
            let valToReturn = false;
            const currentIndex = this.draggableColumns.findIndex(elem => JSON.stringify(elem) === JSON.stringify(item));
            for (let i = 0; i < this.draggableColumns.length; i++) {
                if ((i !== currentIndex && this.draggableColumns[i].code
                && codeToReturn === this.draggableColumns[i].code
                && this.draggableColumns[i].checked) || codeToReturn === "id") {
                    valToReturn = true;
                    this.draggableColumns[i].errorCode = true;
                    break;
                }
            }
            return valToReturn;
        },
        checkDuplicatedColName(item) {
            const nameToReturn = typeof item === "string" ? item : item.name;
            let valToReturn = false;
            const currentIndex = this.draggableColumns.findIndex(elem => JSON.stringify(elem) === JSON.stringify(item));
            for (let i = 0; i < this.draggableColumns.length; i++) {
                if ((i !== currentIndex && this.draggableColumns[i].name
                && nameToReturn === this.draggableColumns[i].name
                && this.draggableColumns[i].checked) || nameToReturn === "ID") {
                    valToReturn = true;
                    this.draggableColumns[i].error = true;
                    break;
                }
            }
            return valToReturn;
        },
        checkAlphaColValues() {
            for (let i = 0; i < this.draggableColumns.length; i++) {
                if (this.draggableColumns[i].checked) {
                    if (!this.draggableColumns[i].name) {
                        this.draggableColumns[i].error = true;
                    } else if (!this.validatePatternName.test(this.draggableColumns[i].name)) {
                        this.draggableColumns[i].error = true;
                    } else if (this.checkDuplicatedColName(this.draggableColumns[i])) {
                        this.draggableColumns[i].error = true;
                    } else {
                        this.draggableColumns[i].error = false;
                    }
                    if (!this.draggableColumns[i].code) {
                        this.draggableColumns[i].errorCode = true;
                    } else if (!this.validatePatternCode.test(this.draggableColumns[i].code)) {
                        this.draggableColumns[i].errorCode = true;
                    } else if (this.checkDuplicatedColCode(this.draggableColumns[i])) {
                        this.draggableColumns[i].errorCode = true;
                    } else {
                        this.draggableColumns[i].errorCode = false;
                    }
                }
            }
            this.inputCodeKey++;
        },
        defaultValMth(val) {
            let returnType = null;
            if (val && val.length) {
                if (typeof val === "object") {
                    returnType = val[0].value;
                } else {
                    returnType = val;
                }
            }
            return returnType;
        },
        changeColumnStatus(data) {
            this.draggableColumns.forEach(obj => {
                obj.checked = data;
            });
            this.selectedFields = data ? [...this.allColumnIDs] : [];
            for (let i = 0; i < this.initialVals.length; i++) {
                for (let j = 0; j < this.draggableColumns.length; j++) {
                    if (this.initialVals[i].uuid === this.draggableColumns[j].uuid) {
                        this.draggableColumns[j].name = this.initialVals[i].name;
                        this.draggableColumns[j].code = this.initialVals[i].code;
                        this.draggableColumns[j].type = this.initialVals[i].type;
                        this.draggableColumns[j].error = false;
                        this.draggableColumns[j].errorCode = false;
                    }
                }
            }
            this.checkColValuesImport();
        },
        triggerCheckboxColumn(item) {
            this.allColumns = this.selectedFields.length === this.allColumnIDs.length;
            const found = this.selectedFields.find(elem => elem === item.uuid);
            if (!found) {
                for (let i = 0; i < this.initialVals.length; i++) {
                    if (item.uuid === this.initialVals[i].uuid) {
                        item.name = this.initialVals[i].name;
                        item.code = this.initialVals[i].code;
                        item.type = this.initialVals[i].type;
                        item.error = false;
                        item.errorCode = false;
                    }
                }
            }
            item.checked = found;
            this.checkColValuesImport();
        },
        showProperties(uuid) {
            let showContainer = false;
            const elToReturn = this.selectedFields.find(elem => elem === uuid);
            if (elToReturn || elToReturn === "") {
                showContainer = true;
            }
            return showContainer;
        },
        checkColValuesImport() {
            for (let i = 0; i < this.draggableColumns.length; i++) {
                this.draggableColumns[i].error = this.draggableColumns[i].checked && (!this.validatePatternName.test(this.draggableColumns[i].name)
                    || this.checkDuplicatedColName(this.draggableColumns[i]));
            }
        },
        checkColValuesImportCode() {
            for (let i = 0; i < this.draggableColumns.length; i++) {
                const { code, name, checked, error } = this.draggableColumns[i];
                this.draggableColumns[i].errorCode = checked && (
                    (Boolean(code) && !this.validatePatternCode.test(code))
                    || (Boolean(code) && this.checkDuplicatedColCode(this.draggableColumns[i]))
                    || (Boolean(name) && !error && !code)
                );
            }
        }
    }

};
